<template>
  <v-container class="designfiletype">
    <v-sheet
      min-height="300"
      rounded="lg"
      elevation="6"
    >
    <Toolbar
      :handle-submit="onSendForm"
      :handle-reset="resetForm"
      :handle-delete="del"
      >
        <template slot="left">
          <v-toolbar-title v-if="item" class="hidden-md-and-down toolbartitle_50"  >
            <h1><v-icon large>mdi-file-cad</v-icon>{{ $t('designfile.designfiletype')}}</h1>
          </v-toolbar-title>
        </template>
    </Toolbar>
    <DesignFileTypeForm
      ref="updateForm"
      v-if="item"
      :values="item"
      :errors="violations"
    />
    <Loading :visible="isLoading || deleteLoading" />
  </v-sheet>
  </v-container>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import DesignFileTypeForm from '../../components/designfiletype/Form.vue';
import Loading from '../../components/Loading';
import Toolbar from '../../components/Toolbar';
import UpdateMixin from '../../mixins/UpdateMixin';
import AccessMixin from '../../mixins/AccessMixin';

const servicePrefix = 'DesignFileType';

export default {
  name: 'DesignFileTypeUpdate',
  servicePrefix,
  mixins: [UpdateMixin,AccessMixin],
  components: {
    Loading,
    Toolbar,
    DesignFileTypeForm
  },

  computed: {
    ...mapFields('designfiletype', {
      deleteLoading: 'isLoading',
      isLoading: 'isLoading',
      error: 'error',
      updated: 'updated',
      violations: 'violations'
    }),
    ...mapGetters('designfiletype', ['find'])

  },

  methods: {
    ...mapActions('designfiletype', {
      deleteItem: 'del',
      retrieve: 'load',
      update: 'update',
    })
  }
};
</script>
